// src/views/kiddo-games/letters/RulesOfTheGame.tsx
import React from 'react';
import GameRulesText from '../../../components/InfoButton/GameRulesText';

const RulesOfTheGame = () => (
  <>
    <p style={{ color: 'darkslategray', margin: '0' }}>
      <GameRulesText game="letters" />
    </p>
  </>
);

export default RulesOfTheGame;
